import { useNavigate } from 'react-router-dom'

import { Button } from '@/components/ui/Button'
import { EmptyState } from '@/components/ui/EmptyState'
import {
  useMarkAllRead,
  useMarkRead,
  useNotificationsQuery,
} from '@/features/notifications/hooks/useNotifications'
import { formatDateTime } from '@/utils/format'

export function NotificationsPage() {
  const navigate = useNavigate()
  const { data, isPending } = useNotificationsQuery(50)
  const markRead = useMarkRead()
  const markAllRead = useMarkAllRead()

  const notifications = data?.notifications ?? []
  const unreadCount = data?.meta.unreadCount ?? 0

  const handleClick = (id: string, link: string | null, readAt: string | null) => {
    if (!readAt) markRead.mutate(id)
    if (link) void navigate(link)
  }

  return (
    <>
      <div className="my-4 d-flex align-items-center justify-content-between flex-wrap gap-2 page-header-breadcrumb">
        <div>
          <p className="fw-semibold fs-20 mb-0">Notifications</p>
        </div>
        {unreadCount > 0 && (
          <Button
            variant="ghost"
            loading={markAllRead.isPending}
            onClick={() => markAllRead.mutate()}
          >
            Mark all as read
          </Button>
        )}
      </div>

      <div className="card custom-card">
        {isPending && <p className="text-muted p-3 mb-0">Loading…</p>}
        {!isPending && notifications.length === 0 && (
          <EmptyState
            heading="No notifications yet"
            message="We'll let you know when something happens."
          />
        )}
        {notifications.map((n) => (
          <button
            key={n.id}
            type="button"
            className={`d-flex align-items-start gap-3 p-3 border-bottom text-start w-100 border-0 bg-transparent ${
              n.readAt ? '' : 'bg-primary-transparent'
            }`.trim()}
            onClick={() => handleClick(n.id, n.link, n.readAt)}
          >
            {!n.readAt && (
              <span
                className="bg-primary rounded-circle flex-shrink-0 mt-2"
                style={{ width: 8, height: 8 }}
                aria-hidden="true"
              />
            )}
            <div className="flex-grow-1">
              <p className={`mb-0 ${n.readAt ? '' : 'fw-semibold'}`.trim()}>{n.title}</p>
              {n.body && <p className="fs-13 text-muted mb-0">{n.body}</p>}
              <p className="fs-12 text-muted mb-0">{formatDateTime(n.createdAt)}</p>
            </div>
          </button>
        ))}
      </div>
    </>
  )
}
